export { default } from './ButtonLayout.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/ButtonLayout/index.js